"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyQuestionType1ToJSON = exports.SurveyQuestionType1FromJSONTyped = exports.SurveyQuestionType1FromJSON = exports.SurveyQuestionType1 = void 0;
/**
 *
 * @export
 */
exports.SurveyQuestionType1 = {
    Unspecified: 'UNSPECIFIED',
    AdRecall: 'AD_RECALL',
    AidedBrandAwareness: 'AIDED_BRAND_AWARENESS',
    TopOfMindAwareness: 'TOP_OF_MIND_AWARENESS',
    AttributeRating: 'ATTRIBUTE_RATING',
    MessageAssociation: 'MESSAGE_ASSOCIATION',
    Favorability: 'FAVORABILITY',
    PurchaseIntent: 'PURCHASE_INTENT',
    Preference: 'PREFERENCE'
};
function SurveyQuestionType1FromJSON(json) {
    return SurveyQuestionType1FromJSONTyped(json, false);
}
exports.SurveyQuestionType1FromJSON = SurveyQuestionType1FromJSON;
function SurveyQuestionType1FromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SurveyQuestionType1FromJSONTyped = SurveyQuestionType1FromJSONTyped;
function SurveyQuestionType1ToJSON(value) {
    return value;
}
exports.SurveyQuestionType1ToJSON = SurveyQuestionType1ToJSON;
